import '../scripts/i18n/bootstrap.js';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { DeveloperDocs } from '../scripts/DeveloperDocs.jsx';
import '../scripts/developer-docs.css';

createRoot(document.getElementById('root')).render(<DeveloperDocs />);
